import { ChangeEvent, useCallback, useEffect, useState } from "react";
import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { SearchDateRangeForm } from "src/components/common/form/search/SearchDateRangeForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { defaultSysCodeDto, SysCodeDto } from "src/dtos/code/sysCodeDto";
import { CustomerResponseDto } from "src/dtos/customer/customerResponseDto";
import useUiuxStore from "src/store/useUiuxStore";
import { useCommonCodeStore } from '../../../../store/useCommonCodeStore';
import { defaultSAL2080_R01Filter, useSAL2080_R01Store } from "./Store_SAL2080_R01";
import { CompanyDto } from "src/dtos/company/companyDto";
import { getCustomerList } from "src/apis/customerApi";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";


interface Props {
    className?: string;
}

export const SearchSection_SAL2080_R01 = ({ 
}: Props) => {

	const {
		SAL2080_R01Filter, setSAL2080_R01Filter,
		SAL2080_R01List
	 } = useSAL2080_R01Store();

	 const { 
		compCdList,
	} = useCommonCodeStore();



	// 발행여부 (임시로 하드코딩)
	const taxBillingList: SysCodeDto[] = [
		{ 
			...defaultSysCodeDto,
			valueIndex: 0, orderIndex: 0, orderIndexSeq: 0,
			majorCd: 'TAX_BILLING', 
			minorCd: 'Y', 
			codeNm: '발행',
			sysFlg: 'Y',
			dispSeq: 1,
			ref01: '', ref02: '', ref03: '', ref04: '', ref05: '',
			ref06: '', ref07: '', ref08: '', ref09: '', ref10: '',
			remark: ''
		},
		{ 
			...defaultSysCodeDto,
			valueIndex: 0, orderIndex: 0, orderIndexSeq: 0,
			majorCd: 'TAX_BILLING', 
			minorCd: 'N', 
			codeNm: '미발행',
			sysFlg: 'Y',
			dispSeq: 2,
			ref01: '', ref02: '', ref03: '', ref04: '', ref05: '',
			ref06: '', ref07: '', ref08: '', ref09: '', ref10: '',
			remark: ''
		},
	];


    // 달력 팝업 노출 여부 상태
    const [pickerVisible, setPickerVisible] = useState(false);
    const [pickerPosition, setPickerPosition] = useState<{ top: number; left: number }>({ top: 0, left: 0 });
    
    const { setCodeSearchModalProps } = useUiuxStore();
    const [customerName, setCustomerName] = useState<string>(''); // 거래처명 표시용

	const custInfoHandleFoucsId = 'infoCustInput_search';

	// Info 폼 코드 검색 필드 설정
	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'customCd',
			category: '거래처',
			focusId: custInfoHandleFoucsId,
			responseMapping: {
				customCd: 'customCd',
				customNm: 'customNm',
			},
			searchFunction: async (code: string) => {
				const customerResponse = await getCustomerList('all');
				return customerResponse.data.data.find(value => value.customCd === code);
			}
		},		
	];

    // 거래처코드 입력 핸들러
    const handleCustChange = (e: ChangeEvent<HTMLInputElement>) => {
        setSAL2080_R01Filter({ customCd: e.target.value });
    };

    // 거래처 검색 더블클릭 핸들러
    const handleCustDoubleClick = useCallback((e: React.MouseEvent<HTMLInputElement>) => {
        e.currentTarget.blur();
        getFieldHandlers('customCd').onDoubleClick(e);
    }, [SAL2080_R01Filter.customCd]);

	// Info 폼 이벤트 훅 사용
	const { getFieldHandlers } = useInfoFormEvents({
		editData: SAL2080_R01Filter,
		setEditData: setSAL2080_R01Filter,
		defaultData: defaultSAL2080_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'SAL2080_R01_search'
	});

    // customCd가 변경될 때 customerName 초기화
    useEffect(() => {
        if (SAL2080_R01Filter.customCd === '') {
            setCustomerName('');
        }
    }, [SAL2080_R01Filter.customCd]);

    return (
        <div className="w-full">
            <SearchSectionForm buttonText="세금계산서검색">
                <SearchDropDownForm<CompanyDto>
                    label="사업장"
                    value={SAL2080_R01Filter.compCd}
                    optionList={compCdList}
                    onChangeValue={v => setSAL2080_R01Filter({ compCd: v === 'all' ? '' : v })}
                />
                <SearchDateRangeForm
                    label="발행기간"
                    visible={pickerVisible}
                    setVisible={setPickerVisible}
                    dateRange={SAL2080_R01Filter.issuedDateRange}
                    setDateRange={v => setSAL2080_R01Filter({ issuedDateRange: v })}
                    pickerPosition={pickerPosition}
                    setPickerPosition={setPickerPosition}
                />
                <SearchDropDownForm<SysCodeDto>
                    label="발행여부"
                    value={SAL2080_R01Filter.taxBilling}
                    optionList={taxBillingList}
                    onChangeValue={v => setSAL2080_R01Filter({ taxBilling: v === 'all' ? '' : v })}
                />

                <SearchCodeModalForm
                    label="거래처"
                    value={SAL2080_R01Filter.customCd}
                    valueLabel={SAL2080_R01Filter.customNm}
					handleFoucsId={custInfoHandleFoucsId}
					onChange={handleCustChange}
					onDoubleClick={handleCustDoubleClick}
					onKeyDown={getFieldHandlers('customCd').onEnterKeyDown}
                />
            </SearchSectionForm>
        </div>
    );
};
